import gql from "graphql-tag";

export const GET_INBOX_QUESTS = gql`
	query GetInboxQuests {
		GetInboxQuests {
			id
			timeStamp
			triggerEventId
			value
			questStatus
			completionStatus
			questContentEn
			questContentDe
			threshold
			caseInfo {
				caseId
				isAssignee
				patientId
				currency
				therapyDecision
				userRole
			}
			brandName
			owner {
				id
				firstName
				lastName
			}
			resolvedBy {
				id
				firstName
				lastName
			}
			isAutoCompleted
		}
	}
`;

export const READ_OR_UNREAD_QUEST = gql`
	mutation ReadOrUnreadQuest($questId: ID!, $questStatus: TaskStatus!) {
		ReadOrUnreadQuest(questId: $questId, questStatus: $questStatus)
	}
`;

export const TAKE_QUEST_OWNERSHIP = gql`
	mutation TakeQuestOwnership($questId: ID!, $ownerId: String!) {
		TakeQuestOwnership(questId: $questId, ownerId: $ownerId, hasOwner: false)
	}
`;

export const REMOVE_QUEST_OWNERSHIP = gql`
	mutation RemoveQuestOwnership($questId: ID!, $ownerId: String!) {
		RemoveQuestOwnership(questId: $questId, ownerId: $ownerId, hasOwner: true)
	}
`;

export const CHANGE_QUEST_STATUS = gql`
	mutation ChangeQuestStatus($questId: ID!, $questCompletionStatus: QuestCompletionStatus!, $ownerId: String!) {
		ChangeQuestStatus(questId: $questId, questCompletionStatus: $questCompletionStatus, ownerId: $ownerId)
	}
`;

export const QUESTS_SUBSCRIPTION = gql`
	subscription OnQuestUpdated {
		questUpdated
	}
`;
